import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import CanidateStatusRequestModel from "../../../../models/admin/candidate/request/CanidateStatusRequestModel";
import { FORM_SELECT_RULE } from "../../../../utils/validation-utils";
import IdNameModel from "../../../../models/common/IdNameModel";
import toasterUtils from "../../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface FollowupUpdateProps {
    objCandidate: CanidateStatusRequestModel;
    statusList: IdNameModel[];
    onFollowupClose: () => void;
    onFollowupUpdate: (objCandidate: CanidateStatusRequestModel) => void;
}

const TodayFollowupUpdateComponent = (props: FollowupUpdateProps) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            ...props.objCandidate,
            followUpDate: props.objCandidate.followUpDate ? (dayjs(props.objCandidate.followUpDate) as any) : null,
        },
    });

    const onSubmit = (formData: CanidateStatusRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (formData.statusId !== 0 && formData.followUpDate !== null) {
            props.onFollowupUpdate(formData);
        } else {
            toasterUtils.showError("Follow Up Date & Status are Mandatory");
            return;
        }
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-6">
                            <Controller name="statusId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.statusList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.statusList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Status" size="small" required margin="normal" fullWidth error={!!errors.statusId} helperText={errors.statusId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="followUpDate" control={control} rules={{ required: "Next follow-up date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="Next Follow-up Date"
                                                value={field.value}
                                                onChange={field.onChange}
                                                format="YYYY-MMM-DD"
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <FormControl fullWidth margin="normal" error={!!errors.comments}>
                                <TextField label="Comments" size="small" multiline rows={3}
                                    {...register("comments", { required: false })} error={!!errors.comments} helperText={errors.comments?.message} placeholder="Add comments" autoComplete="off" />
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                                Update
                            </Button>
                            <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onFollowupClose}>
                                Close
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default TodayFollowupUpdateComponent;